import React, { useEffect, useState } from 'react'

import { Button, Alert, ListGroup, Form } from 'react-bootstrap'

import toast from 'react-hot-toast'

import { fetchSERStatus, fetchSEREngines, SER_IN_PROGRESS } from '../api'

import SERTranscriptList from '../SERTranscriptList'

export default (props) => {
    const { handleAutoSER, refreshMediaData, id, pendingSERs, mediaData } =
        props

    const [engines, setEngines] = useState([])

    useEffect(() => {
        fetchSEREngines()
            .then((data) => setEngines(data))
            .catch((err) => console.error('Failed to load SER engines:', err))
    }, [])

    // SER annotates an existing transcript with emotions, so the media must
    // already have a default transcript before a job can be submitted.
    const hasDefaultTranscript = Boolean(mediaData['_defaultTranscript'])

    const transcriptOptions = (mediaData['_transcripts'] || []).filter(
        (transcript) => !transcript.isSer
    )

    const renderCurrentJobs = () => {
        if (pendingSERs.length === 0) {
            return <Alert variant="dark">No jobs running currently.</Alert>
        }

        return (
            <ListGroup>
                {pendingSERs.map((ser) => (
                    <ListGroup.Item key={ser['_id']}>
                        <div>{JSON.stringify(ser)}</div>
                        <div className="mt-3">
                            <Button
                                variant="outline-secondary"
                                type="button"
                                size="sm"
                                onClick={() => {
                                    handleRefreshSER(ser['serId'])
                                }}
                            >
                                Refresh
                            </Button>
                        </div>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        )
    }

    const handleRefreshSER = async (serId) => {
        toast
            .promise(
                fetchSERStatus(id, serId),
                {
                    loading: `Checking status for SER Request: ${serId}`,
                    success: (data) => `${data}`,
                    error: (err) => `${err}`,
                },
                {
                    error: {
                        duration: 3000,
                        icon: '🕑',
                    },
                }
            )
            .then((data) => {
                refreshMediaData()
            })
            .catch((err) => {
                if (String(err) === SER_IN_PROGRESS) return
                console.error(err)
            })
    }

    return (
        <div className="px-2 py-4 d-flex flex-column">
            <div>
                <h3>Emotion Recognition</h3>
                <h5 className="mt-4">Current Running Jobs</h5>
                <div>{renderCurrentJobs()}</div>
                <h5 className="mt-3">Send a new emotion recognition job</h5>
                <div className="mt-3 p-4 border rounded-3 d-flex flex-column">
                    {!hasDefaultTranscript && (
                        <Alert variant="warning">
                            Emotion recognition annotates an existing transcript
                            with emotions. This recording has no default
                            transcript yet — generate a transcript (ASR) or
                            upload one first.
                        </Alert>
                    )}
                    <Form onSubmit={handleAutoSER}>
                        {engines.length > 0 && (
                            <Form.Group controlId="engineSelect">
                                <Form.Label>SER Engine</Form.Label>
                                <Form.Control as="select" name="engine" custom>
                                    {engines.map((engine) => (
                                        <option key={engine['id']} value={engine['id']}>
                                            {engine['label'] || engine['id']}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        )}
                        <Form.Group controlId="transcriptSelect">
                            <Form.Label>Transcript for SER</Form.Label>
                            <Form.Control
                                as="select"
                                name="transcript"
                                defaultValue={mediaData['_defaultTranscript']}
                                custom
                            >
                                {transcriptOptions.map((transcript) => (
                                    <option key={transcript['_id']} value={transcript['_id']}>
                                        {transcript['name'] || transcript['_id']}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={!hasDefaultTranscript}
                        >
                            Submit
                        </Button>
                    </Form>
                </div>
            </div>
            <div className="mt-4">
                <div className="md-4">
                    <h4>Transcripts</h4>
                </div>
                <SERTranscriptList
                    id={id}
                    mediaData={mediaData}
                    refreshMediaData={refreshMediaData}
                />
            </div>
        </div>
    )
}
